var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showImproveQuestion)?_c('router-link',{staticClass:"improve-question-container",attrs:{"to":_vm.improveQuestionRoute}},[_c('icon',{attrs:{"name":"info","variant":"516173"}}),_vm._v(" "),_c('span',[_vm._v("Improve this question")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }